<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">CHECKBOOK PROCESS</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md12>
            <v-select
              class="mx-2"
              v-model="bank_code"
              dense
              outlined
              label="Bank Code"
              :items="bank_code_items"
              item-value="bank_code_with_act_no"
              item-text="bank_code_with_act_no"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              class="mx-2"
              v-model="from_no"
              dense
              label="From"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              class="mx-2"
              v-model="to_no"
              dense
              label="To"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="number"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"
            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{ alert_message }}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>

import {mdiAlertOutline} from "@mdi/js";
import {mapActions, mapGetters} from "vuex";

const initialState = () => {
  return {
    saving_request: false,
    alert: false,
    alert_message: '',
    particulars: '',
    from_no: 0,
    to_no: 0,

    bank_code: '',
    bank_code_items: [],
  }
}
export default {
  props: {
    category_id: Number,
    branch_id: Number,
    particulars_id: Number,
    particulars_data_id: Number,
    particulars_description_items: Array,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
      },
    }
  },
  data() {
    return initialState();
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
  },
  mounted() {
    this.list_of_bank_with_cheque({
      category_id: this.category_id,
    })
      .then(response => {
        this.bank_code_items = response.data
      })
  },
  methods: {
    ...mapActions('bank_depository', ['list_of_bank_with_cheque']),
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    done_request() {
      this.saving_request = true
      this.alert = false
      if (this.$refs.form.validate()) {
        this.$emit('data', this.bank_code + ' # Desc.-from ' + this.from_no + ' to ' + this.to_no)
        this.saving_request = false
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving_request = false
      }
    },
  }
}
</script>
